export default __webpack_public_path__ + "static/media/sorting-down.4b4f1592.svg";